import { render, staticRenderFns } from "./SlideCustomerList.vue?vue&type=template&id=961f1aa4&scoped=true"
import script from "./SlideCustomerList.vue?vue&type=script&lang=js"
export * from "./SlideCustomerList.vue?vue&type=script&lang=js"
import style0 from "./SlideCustomerList.vue?vue&type=style&index=0&id=961f1aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961f1aa4",
  null
  
)

export default component.exports